import { usePageParams } from 'hooks/use-page-params';
import { useQuery } from 'react-query';
import http from '../config/http-service';
import type { MasterProductFamilyListResponse } from './types';

// GET api/v1/cms/master-product-families — paged list, driven by URL params.
export const masterProductFamiliesEndpoint = 'api/v1/cms/master-product-families';

const str = (v: unknown): string | undefined => (typeof v === 'string' && v ? v : undefined);
const num = (v: unknown): number | undefined => {
  const n = Number(v);
  return typeof v === 'string' && v !== '' && !Number.isNaN(n) ? n : undefined;
};

export const useGetMasterProductFamiliesApi = (options: { onError?: (error: any) => void } = {}) => {
  const { getPageParams } = usePageParams();
  const params = getPageParams();

  const queryKey = [masterProductFamiliesEndpoint, params.page, params.limit, params.universalName, params.catalogCategoryId];

  return useQuery({
    queryKey,
    queryFn: async (): Promise<MasterProductFamilyListResponse> => {
      const { data } = await http.get(masterProductFamiliesEndpoint, {
        params: {
          page: num(params.page) || 1,
          limit: num(params.limit) || 20,
          universalName: str(params.universalName),
          // BE expands this to self + descendant categories, so an L1/L2
          // grouping id matches every family underneath it.
          catalogCategoryId: num(params.catalogCategoryId),
        },
      });
      return data;
    },
    onError: options.onError,
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
  });
};
